import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Snackbar, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const AlertPopup = (props) => {
    const alert = useSelector((state) => state.alert);
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (alert) {
            setOpen(true);
        }
    }, [alert]);

    return (
        alert && (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
            >
                {alert.type === 'error' ? (
                    <Alert
                        elevation={5}
                        variant="filled"
                        severity="error"
                        onClose={handleClose}
                    >
                        {alert.message}
                    </Alert>
                ) : (
                    <Alert
                        severity="success"
                        elevation={5}
                        variant="filled"
                        onClose={handleClose}
                    >
                        {alert.message}
                    </Alert>
                )}
            </Snackbar>
        )
    );
};

export default AlertPopup;
